import _classCallCheck from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    _classCallCheck(this, Invalid);
    this.reason = reason;
    this.explanation = explanation;
  }
  _createClass(Invalid, [{
    key: "toMessage",
    value: function toMessage() {
      if (this.explanation) {
        return "".concat(this.reason, ": ").concat(this.explanation);
      } else {
        return this.reason;
      }
    }
  }]);
  return Invalid;
}();
export { Invalid as default };